<aside class="lh-sidebar">
  <app-learning-hub-search-box [lang]="lang"></app-learning-hub-search-box>

  <section class="lh-sidebar-block" *ngIf="current && currentArticles.length">
    <h2 class="lh-sidebar-eyebrow">{{ 'learningHub.categories.' + current.key | lhTranslate: lang }}</h2>
    <ul class="lh-sidebar-list lh-sidebar-list--ruled">
      <li *ngFor="let article of currentArticles">
        <a
          class="lh-sidebar-link"
          [class.active]="article.id === currentArticleId"
          [attr.aria-current]="article.id === currentArticleId ? 'page' : null"
          [routerLink]="['/', modulePath, article.lang, article.slug]"
          >{{ article.title }}</a
        >
      </li>
    </ul>
  </section>

  <nav class="lh-sidebar-block" [attr.aria-label]="'learningHub.sectionsTitle' | lhTranslate: lang">
    <h2 class="lh-sidebar-title">{{ 'learningHub.sectionsTitle' | lhTranslate: lang }}</h2>
    <ul class="lh-sidebar-list">
      <li *ngFor="let section of sections">
        <a
          class="lh-sidebar-link"
          [class.active]="section.category.key === activeKey"
          [class.expanded]="section.category.key === activeParent"
          [attr.aria-current]="section.category.key === activeKey && currentArticleId === null ? 'page' : null"
          [routerLink]="section.link"
          [queryParams]="{ lang: lang }"
          >{{ 'learningHub.categories.' + section.category.key | lhTranslate: lang }}</a
        >
        <ul class="lh-sidebar-list lh-sidebar-list--ruled lh-sidebar-children" *ngIf="section.children.length">
          <li *ngFor="let child of section.children">
            <a
              class="lh-sidebar-link"
              [class.active]="child.category.key === activeKey"
              [attr.aria-current]="child.category.key === activeKey && currentArticleId === null ? 'page' : null"
              [routerLink]="child.link"
              [queryParams]="{ lang: lang }"
              >{{ 'learningHub.categories.' + child.category.key | lhTranslate: lang }}</a
            >
          </li>
        </ul>
      </li>
    </ul>
  </nav>

  <section class="lh-sidebar-block" *ngIf="staffPicks.length">
    <h2 class="lh-sidebar-title">{{ 'learningHub.staffPickTitle' | lhTranslate: lang }}</h2>
    <ul class="lh-sidebar-list">
      <li *ngFor="let article of staffPicks">
        <a class="lh-sidebar-link" [routerLink]="['/', modulePath, article.lang, article.slug]">{{ article.title }}</a>
      </li>
    </ul>
  </section>
</aside>
